import * as Locale from "./util/Locale.ts";
import links from "./nls/link.js";
import manualFamilyWall from "./nls/manual.js";
import localFamilyWall from "./nls/transifex.js";

var
  // Declare aliases

  // Private fields

  // languages - array, the list of language objects, sorted by language
  //             code, in case-insensitive lexical order.
  //             Each language object is in the format:
  //             | {
  //             |    code: 'en-US', // string, language code
  //             |    properties: {...}  // object, properties given
  //             |                       // in addLanguageProperties
  //             | }
  // Note:
  // In current implementation, the same language code may be repeated in
  // several language objects. These duplicates may be merged into a single
  // language object in a future implementation (trading less memory for
  // more computations due to added merging step).
  languages = [],
  chosenLanguage;
// Private functions


function selectLanguage(languageCode){
  chosenLanguage = Locale.set(languageCode);
  loadLanguage();
}

function getSelectedLanguage(){
  return chosenLanguage;
}
function getShortLanguage() {
  var
    i = chosenLanguage.indexOf('-');
  if(i===-1){
    return chosenLanguage;
  }else{
    return chosenLanguage.substring(0,i);
  }
}

function getLocalValue(key){
  try{
    key = key.split('.');
  }catch(e){
    return "";
  }
  var i,properties,j,length;

  // for each language, from most specific (last) to least specific (first)
  langloop:for (i=languages.length-1; i>=0; i--){
    properties = languages[i];
    // for each path element in the given key
    for (j=0, length=key.length; j<length; j++){
      // go on with next level (may be null or undefined)
      properties = properties[key[j]];
      if (properties===undefined||properties===null){
        continue langloop;
      }
    }
    return properties;
  }
  return null;
}

/*
  Function: get(key[,data[,languageCode]])
  Get a localized value with optional data used to compute the value in a
  localized function

  Parameters:
    key - string, the name of the looked up property such as 'name',
      or string, a dotted string such as 'section.subsection.name',
      or an array of strings to represent a path to a property
      such as ['section','subsection','name'] nested within sections
      and subsections
    data - object, optional, object provided as second argument to a
      localized function(key,data,languageCode) associated with the key,
      called to compute the actual value
    languageCode - string, optional, the language code used to filter
      relevant languages, defaults to the value of getDefaultLanguageCode()

  Returns:
    * any, the value of the property found in the most specific language
      object whose language code put in lower case is a hyphenated
      substring of the given language code put in lower case,
      or if the value is a function, the value returned by calling the
      function with the key, data and languageCode as arguments
    * or null if the property is not found in suitable languages,
      if the given path is null or undefined, or if the given language
      code is not a string.
*/
function get(key :string, data = {}){
  try{
    var localValue = getLocalValue(key);
    while(typeof localValue !== 'string'){
      if (typeof localValue === 'function'){
        localValue = localValue.apply(null,arguments);
      }
      if (localValue === null || localValue === undefined ) {
        return key;
      }
      if(typeof localValue === 'object'){
        if(typeof data==='number'){
          if(localValue[data]!==undefined){
            localValue = localValue[data];
          }else{
            localValue = localValue.N;
          }
        }else{
          //console.log(new Error("weird i18n "+key))
          return localValue;
        }
      }
    }
  }catch(e){
    console.log('error with '+key)
  }
  localValue = localValue.replace(/\$\{([^{]*)\}/g,function(toreplace,key){
    var transformed;
    if(key==='.'){
      transformed =data;
    }else if(data && data[key]!==undefined){
      transformed = data[key];
    }else if(key[0]===':'){
      let keySplit = key.substring(1).split('.');
      keySplit.forEach(subKey=>data=data[subKey]);
      transformed = data;
    }
    if(transformed!==undefined){
      if(transformed instanceof Date){
        return new Intl.DateTimeFormat(getSelectedLanguage(), { dateStyle: 'full' }).format(transformed)
      }
      return transformed;
    }
    return get(key,data);
  });
  return localValue;
}

export function getSafe(key :string, data = {}){
  var result = get(key,data);
  //TODO create a clean class for this
  return {toHTML(){return result},toString(){return result}}
}


function getMustache(key,data){
  var localValue = getLocalValue(key);
  localValue = localValue.replace(/\{\{([^}]*)\}\}/g,function(toreplace,key){
    if(key==='.'){
      return data;
    }
    let replacement = data[key];
    if(typeof replacement === 'function'){
      replacement = replacement.apply(data);
    }
    return replacement;
  });

  return localValue;
}

function loadLanguage(){
  var
    localeForText = getShortLanguage();

  // load only relevant language properties based on locale
  // and partner
  if ([ "en", "fr", "es", "de" ,"pt","sq","it","nl","ja","ru","ko","sv","key"].indexOf(localeForText) === -1) {
    localeForText = "en";
  }
  if(localeForText==='key'){
    languages = [];
  }else{
    languages = [];
    languages.push(links);
    languages.push(manualFamilyWall.root);
    languages.push(localFamilyWall.root);

    if(localeForText!=='en'){
      languages.push(manualFamilyWall[localeForText]);
      languages.push(localFamilyWall[localeForText]);
    }

  }
}



export function getCountry(countryCode :string, langCode :string){
  var
    countryNameWriter = getIntlDisplayNames(getSelectedLanguage(),'region'),
    langNameWriter = getIntlDisplayNames(getSelectedLanguage(),'language'),
    result :string;

  result = countryNameWriter.of(countryCode);
  if(langCode){
    result += ' ('+langNameWriter.of(langCode) +')'
  }
  return result;
}
export function getIntlDisplayNames(lang :string,type :Intl.DisplayNamesType){
  try{
    return new Intl.DisplayNames([lang], { type: type });
  }catch(e){
    console.log('Intl.DisplayNames does not handle "'+lang+'" fallback to "en"');
    return new Intl.DisplayNames(['en'], { type: type });
  }
}
selectLanguage(Locale.get())

export{
		// public API
  selectLanguage,
  getSelectedLanguage,
	getShortLanguage,
	get,
	getMustache
};
